import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../../baseClasses/BaseComponent';

import CloseIcon from '../../../../assets/images/close-icon.svg';
import ReferenceDocumentFilter from './ReferenceDocumentFilter';
import Button from '../../../../components/Buttons/DialogButton';
import dataModel from '../../../../models/DataModel';
import './ReferenceDocumentFilterPopout.scss';

// Change DialogButton to the appropriate name
class ReferenceDocumentFilterPopout extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      changedData: false,
      selectedMarket:
        props.selectedFilters && props.selectedFilters.market
          ? props.selectedFilters.market
          : null,
      selectedDocumentType:
        props.selectedFilters && props.selectedFilters.documentType
          ? props.selectedFilters.documentType
          : null,
      startDate:
        props.selectedFilters && props.selectedFilters.startDate 
        ? props.selectedFilters.startDate
        : null,
      endDate:
        props.selectedFilters && props.selectedFilters.endDate 
        ? props.selectedFilters.endDate
        : null,
      selectedFilters: props.selectedFilters ? props.selectedFilters : {},
    };
  }

  handleMarketSelection(market) {
    let copySelectedFilters = Object.assign({}, this.state.selectedFilters);
    copySelectedFilters.market = market;
    this.setState({ 
      selectedMarket: market,
      selectedFilters: copySelectedFilters,
      changedData: true,
    });
  }

  handleDocumentTypeSelection(documentType) {
    let copySelectedFilters = Object.assign({}, this.state.selectedFilters);
    copySelectedFilters.documentType = documentType;
    this.setState({ 
      selectedDocumentType: documentType,
      selectedFilters: copySelectedFilters,
      changedData: true,
    });
  }

  handleStartDateSelection(date) {
    let copySelectedFilters = Object.assign({}, this.state.selectedFilters);
    copySelectedFilters.startDate = date;
    this.setState({ 
      startDate: date,
      selectedFilters: copySelectedFilters,
      changedData: true,
    });
  }

  handleEndDateSelection(date){
    let copySelectedFilters = Object.assign({}, this.state.selectedFilters);    
    copySelectedFilters.endDate = date;
    this.setState({ 
      endDate: date,
      selectedFilters: copySelectedFilters,
      changedData: true,
    });
  }

  handleApplyFilter() {
    this.props.handleCancel();
    let filter = {};
    if (this.state.selectedMarket) {
      filter.market = this.state.selectedMarket;
    }
    if (this.state.selectedDocumentType) {
      filter.documentType = this.state.selectedDocumentType;
    }
    if(this.state.startDate){
      filter.startDate = this.state.startDate;
    }
    if(this.state.startDate){
      filter.endDate = this.state.endDate;
    }
    if (this.props.handleApplyFilter) {
      this.props.handleApplyFilter(filter);
    }
  }

  handleCancel() {
    this.props.handleCancel();
    this.setState({
      changedData: false,
      selectedFilters: null,
      selectedMarket: null,
      selectedDocumentType: null,
    });
  }

  handleClear() {
    this.props.handleClear();
    this.setState({
      changedData: false,
      selectedFilters: null,
      selectedMarket: null,
      selectedDocumentType: null,
    });    
  }

  render() {
    const { right, top } = this.props;

    let style = { 
      right: right, 
      top: top, 
    };

    return (
      <div className="reference-docs-filter-popout-container" style={style}>
        <div className="arrow-up" />
        <div className="reference-docs-filter-popout-header">
          <div className="reference-docs-filter-popout-title">{'FILTER DOCUMENT LIBRARY'}</div>
          <img
            className="reference-docs-filter-popout-close-icon"
            src={CloseIcon}
            alt="close"
            onClick={this.handleCancel}
          />
        </div>
        <div className="reference-docs-filter-popout-filter-container">
          <ReferenceDocumentFilter
            handleMarketSelection={this.handleMarketSelection}
            handleDocumentTypeSelection={this.handleDocumentTypeSelection}
            handleStartDateSelection={this.handleStartDateSelection}
            handleEndDateSelection={this.handleEndDateSelection}
            selectedFilters={this.state.selectedFilters}
            markets={this.props.markets}
          />
        </div>

        <div className="reference-docs-button-container">
          <Button
            width={40}
            height={32}
            text={this.textMap.clear.toUpperCase()}
            fontStyle={{
              color: '#9b9b9b',
              fontFamily: 'Open Sans',
              fontSize: '12px',
              letterSpacing: '0px',
              lineHeight: '32px',
            }}
            fill="#ffffff"
            handleClick={this.handleClear}
          />
          {this.state.changedData ? 
          <Button
            width={60}
            height={32}
            text={this.textMap.apply.toUpperCase()}
            fontStyle={{
              color: '#ffffff',
              fontFamily: 'Open Sans',
              fontSize: '12px',
              letterSpacing: '0px',
              lineHeight: '32px',
            }}
            fill="#5db348"
            handleClick={this.handleApplyFilter}
          /> :
          <Button
            width={60}
            height={32}
            text={this.textMap.apply.toUpperCase()}
            disabled={true}
            border={'solid 1px #5db348'}
            fontStyle={{
              color: '#5db348',
              fontFamily: 'Open Sans',
              fontSize: '12px',
              letterSpacing: '0px',
              lineHeight: '32px',
            }}
            fill="#ffffff"
          />
        }
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    currentCompany: state.new_companies.currentCompany,
  };
};

// For handling state change from a dispatch
const mapDispatchToProps = dispatch => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(ReferenceDocumentFilterPopout);



// WEBPACK FOOTER //
// ./src/containers/ReferenceDocumentsLibrary/ReferenceDocumentSearchFilter/ReferenceDocumentFilterPopout/index.js